import React from 'react'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { OptionsHOC } from '../../hocs'

const ProductNameHOC = WrappedComponent => {
  const ProductName = ({ language, getOption, ...parentProps }) => {
    const productTranslation = messages[language]
    const props = {
      ...parentProps,
      language,
      getOption,
      productTranslation: productTranslation,
      productNameSingular: getOption('productName.productSingular'),
      productNamePlural: getOption('productName.productPlural')
    }

    return <WrappedComponent {...props} />
  }

  return LanguageProvider(OptionsHOC(ProductName))
}

export default ProductNameHOC



// WEBPACK FOOTER //
// ./src/hocs/ProductNameHOC/index.js